<div class="container-fluid" style="background-color: #f6efe8;    direction: ltr;">
    <div style="">

        <div class="row">
            <div class="col-sm-12 col-md-4 " style="
    background-size: cover;
            background-image: url('assets/popup/popup_bg.png');
            background-color: #363636;    min-height: 390px;">
                <div class=" p-4 text-center">

                </div>
            </div>
            <div class="col-sm-12 col-md-8">
                <div *ngIf="!subscription_success" class="p-4">
                    <div class="desc mb-5" [innerHTML]="popup_text"></div>
                    <form id="login" [formGroup]="form" (submit)="subscribe()">


                        <div lass="form-group ">
                            <input type="email"
                                   placeholder="Please insert your email"
                                   id="email"
                                   name="email"
                                   class="form-control"
                                   formControlName="email"
                                   autocomplete="off"
                            >

                        </div>
                        <div class="">
                            <button id="save_new_user_btn" class="btn pt-2 btn-block pb-2 pl-5 pr-5 btn-lg  mt-4"
                                    style="background-color: #363636 ;border-radius: 3px; color: white ;"
                                    type="submit"
                                    i18n>
                                <span *ngIf="!isSending">{{'subscribe' | translate}}</span>
                                <span *ngIf="isSending"><img src="assets/loader.gif" width="20"/> Please wait ...</span>

                            </button>
                            <br>
                            <div class="text-center">
                                <a href="#" id="save_new_user_btn" class=" pt-2 pb-2 pl-5 pr-5 btn-lg  mt-4"
                                   style="font-size: 12px;"
                                   (click)="close($event)"
                                   i18n>
                                    <span>{{'no_thanks' | translate}}</span>

                                </a>
                            </div>

                        </div>
                    </form>
                </div>

                <div class="text-center p-t-30" *ngIf="subscription_success">

                    <fa-icon style="    color: green;
    font-size: 90px;" [icon]="icon_success"></fa-icon>
                    <div style="       font-size: 20px;
    padding: 20px;
    padding-top: 5px;
    font-weight: 100;">{{'subscription_success' | translate}}</div>

                    <div class="text-center">
                        <a href="#" id="save_new_user_btn" class=" pt-2 pb-2 pl-5 pr-5 btn-lg  mt-4"
                           style="font-size: 12px;"
                           (click)="close($event)"
                           i18n>
                            <span>{{'close' | translate}}</span>

                        </a>
                    </div>

                </div>

            </div>
        </div>


        <!--        <div class="container-fluid container-body text-center p-4">-->
        <!--            &lt;!&ndash;    <h5>Welcome to Alarabyia store ! </h5>&ndash;&gt;-->
        <!--       -->
        <!--        </div>-->
    </div>
</div>
